module.exports = __webpack_public_path__ + "static/media/ghost.229f9342.svg";